import React from 'react';
import { PORTAL_FIXTURE } from '../mock/portalFixture';
import { usePortalCopy } from '../PortalUi';
import { PortalAvatar, portalInitials } from '../ui';
import { PortalStatus } from '../api/portalService';
import { agentContactLinks } from '../api/agentContact';
import { AgentContactButtons } from './AgentContactButtons';

export function AgentCard({ application }: { application?: PortalStatus | null }) {
  const t = usePortalCopy();
  const live = Boolean(application);
  const name = live
    ? (application?.agent.name || '')
    : PORTAL_FIXTURE.agent.name;
  const initials = live ? portalInitials(name) : PORTAL_FIXTURE.agent.initials;

  const subject = live
    ? `Solicitud ${application?.reference || ''}`.trim()
    : PORTAL_FIXTURE.recoverSubject;

  const agent = live
    ? application?.agent
    : {
        name: PORTAL_FIXTURE.agent.name,
        phone: PORTAL_FIXTURE.agent.waNumber,
        email: PORTAL_FIXTURE.agent.email,
      };
  const links = agentContactLinks(agent, subject);
  const talkName = links.talkName || (live ? '' : PORTAL_FIXTURE.agent.firstName);

  return (
    <div className="sum">
      <h3>{t('agentTitle')}</h3>
      <div className="agent" style={{ marginTop: 0 }}>
        <PortalAvatar initials={initials} name={name} />
        <div className="who">
          <b>{name}</b>
          {live ? null : <span>{PORTAL_FIXTURE.agent.speaks}</span>}
        </div>
      </div>
      <AgentContactButtons
        talkName={talkName}
        wa={links.wa}
        mail={links.mail}
        writeLabel={t('writeToAgent', { name: talkName })}
        emailLabel={t('emailAgent', { name: talkName })}
        waSpec="o-agent-wa"
        mailSpec="o-agent-mail"
        size="sm"
        fullWidth
        waStyle={{ marginTop: 12 }}
        mailStyle={{ marginTop: links.wa ? 8 : 12 }}
      />
    </div>
  );
}
